// extracted by mini-css-extract-plugin
export default {"container":"_8b61fa56"};